import Vue from 'vue';
const state = {
    withdrawal: {},
    withdrawals: [],
}
const actions = {
    showWithdrawals: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/withdrawals`).then(response => {
                context.commit('SHOW_WITHDRAWLS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showWithdrawal: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/withdrawals/${id}`).then(response => {
                context.commit('SHOW_WITHDRAWL', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storeWithdrawal: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/withdrawals`, payload).then(response => {
                context.commit('STORE_WITHDRAWL', response.data)
                Vue.$toast.success("Retirada registrada com sucesso");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateWithdrawal: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/withdrawals/${payload.id}`, payload).then(response => {
                Vue.$toast.success("Retirada atualizada com sucesso");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyWithdrawal: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/withdrawals/${id}`).then(response => {
                Vue.$toast.success("Retirada deletada com sucesso");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {

    SHOW_WITHDRAWL: (state, payload) => {
        state.withdrawal = payload
    },
    SHOW_WITHDRAWLS: (state, payload) => {
        state.withdrawals = payload
    },
    STORE_WITHDRAWL: (state, payload) => {
        state.withdrawal = payload
    }
}
const getters = {
    withdrawal: state => {
        return state.withdrawal
    },
    withdrawals: state => {
        return state.withdrawals
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}